import Icon from '../components/Icon.vue'

Icon.register({"arrows-h":{"width":1792,"height":1792,"paths":[{"d":"M1792 896q0 26-19 45l-256 256q-19 19-45 19t-45-19-19-45v-128h-1024v128q0 26-19 45t-45 19-45-19l-256-256q-19-19-19-45t19-45l256-256q19-19 45-19t45 19 19 45v128h1024v-128q0-26 19-45t45-19 45 19l256 256q19 19 19 45z"}]}})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/arrows-h.js